<div mat-dialog-content class="progress-dialog">
    <div class="media d-flex align-items-center" style="height: 60px; margin-top: -5px;">
        <mat-spinner class="align-self-center" [diameter]="35" [strokeWidth]="3"></mat-spinner>
        <div class="media-body">
            <p class="mt-0 title-text color-grey-deep" style="margin-left: 15px; line-height: 15px;">{{data.dialogTitle}}</p>
        </div>
    </div>
</div>